export var AspectRatioToken;
(function (AspectRatioToken) {
    AspectRatioToken["A16_9"] = "A16_9";
    AspectRatioToken["A9_16"] = "A9_16";
    AspectRatioToken["A4_3"] = "A4_3";
    AspectRatioToken["A3_4"] = "A3_4";
    AspectRatioToken["A1_1"] = "A1_1";
    AspectRatioToken["A2_1"] = "A2_1";
})(AspectRatioToken || (AspectRatioToken = {}));
export var ResizeModeToken;
(function (ResizeModeToken) {
    ResizeModeToken["COVER"] = "cover";
    ResizeModeToken["CONTAIN"] = "contain";
    ResizeModeToken["STRETCH"] = "stretch";
    ResizeModeToken["REPEAT"] = "repeat";
    ResizeModeToken["CENTER"] = "center";
})(ResizeModeToken || (ResizeModeToken = {}));
export var ImageSizeTokens;
(function (ImageSizeTokens) {
    ImageSizeTokens["XXS"] = "XXS";
    ImageSizeTokens["XS"] = "XS";
    ImageSizeTokens["SM"] = "SM";
    ImageSizeTokens["MD"] = "MD";
    ImageSizeTokens["LG"] = "LG";
    ImageSizeTokens["XL"] = "XL";
    ImageSizeTokens["XXL"] = "XXL";
    ImageSizeTokens["XXXL"] = "XXXL";
    ImageSizeTokens["XXXXL"] = "XXXXL";
    ImageSizeTokens["SIZE_56"] = "SIZE_56";
    ImageSizeTokens["FULL"] = "FULL";
    ImageSizeTokens["Size_40"] = "Size_40";
    ImageSizeTokens["SIZE_304"] = "SIZE_304";
    ImageSizeTokens["Size_380"] = "Size_380";
    ImageSizeTokens["Size_330"] = "Size_330";
    ImageSizeTokens["Size_364"] = "Size_364";
    ImageSizeTokens["SIZE_40"] = "SIZE_40";
    ImageSizeTokens["SIZE_16"] = "SIZE_16";
    ImageSizeTokens["SIZE_22"] = "SIZE_22";
    ImageSizeTokens["Size_60"] = "Size_60";
    ImageSizeTokens["SIZE_64"] = "SIZE_64";
    ImageSizeTokens["SIZE_42"] = "SIZE_42";
    ImageSizeTokens["SIZE_52"] = "SIZE_52";
    ImageSizeTokens["SIZE_32"] = "SIZE_32";
    ImageSizeTokens["SIZE_46"] = "SIZE_46";
})(ImageSizeTokens || (ImageSizeTokens = {}));
export var PaddingSizeTokens;
(function (PaddingSizeTokens) {
    PaddingSizeTokens["NONE"] = "NONE";
    PaddingSizeTokens["XS"] = "XS";
    PaddingSizeTokens["SM"] = "SM";
    PaddingSizeTokens["MD"] = "MD";
    PaddingSizeTokens["LG"] = "LG";
    PaddingSizeTokens["XL"] = "XL";
    PaddingSizeTokens["XXL"] = "XXL";
    PaddingSizeTokens["XXXL"] = "XXXL";
})(PaddingSizeTokens || (PaddingSizeTokens = {}));
